"use strict";
/* eslint compat/compat:"off" */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addGQLKeeperInterceptors = exports.GQL_OPERATION_NAME_HEADER = exports.addKeeperInterceptors = void 0;
var global_1 = require("../global");
var util_now_1 = require("./util.now");
function addKeeperInterceptors(axiosInstance, extra) {
    if (extra === void 0) { extra = {}; }
    // Добавляем мета данные
    addKeeperMeta(axiosInstance);
    // Скидываем метрики
    axiosInstance.interceptors.response.use(
    // 2XX OK
    function (resp) {
        (0, global_1.coreKeeperAPI)(resp, __assign(__assign({}, extra), { duration: getKeeperDuration(resp) }));
        return resp;
    }, 
    // Error handling
    function (err) {
        (0, global_1.coreKeeperAPI)(err.request, __assign(__assign({}, extra), { duration: getKeeperDuration(err) }));
        return Promise.reject(err);
    });
}
exports.addKeeperInterceptors = addKeeperInterceptors;
exports.GQL_OPERATION_NAME_HEADER = 'keeper-gql-op-name';
function addGQLKeeperInterceptors(axiosInstance, responseToStatusOrOptions, extra) {
    if (extra === void 0) { extra = {}; }
    var _a = typeof responseToStatusOrOptions === 'function'
        ? { responseToStatus: responseToStatusOrOptions }
        : responseToStatusOrOptions, responseToStatus = _a.responseToStatus, _b = _a.getOperationName, getOperationName = _b === void 0 ? getOperationNameFromRequestConfig : _b, _c = _a.operationNameHeader, operationNameHeader = _c === void 0 ? exports.GQL_OPERATION_NAME_HEADER : _c, _d = _a.sendOperationNameHeader, sendOperationNameHeader = _d === void 0 ? true : _d;
    // Добавляем мета данные
    addKeeperMeta(axiosInstance);
    var bindedGetOperationNameHandler = function (val) {
        return getOperationName(val, operationNameHeader);
    };
    axiosInstance.interceptors.request.use(function (config) {
        var _a, _b;
        var operationName = (_a = config === null || config === void 0 ? void 0 : config.headers) === null || _a === void 0 ? void 0 : _a[operationNameHeader];
        // Если имя операции содержится в заголовке - достаем его, сейвим в конфиг запроса и удаляем заголовок
        if (typeof operationName === 'string') {
            config.operationName = operationName;
            // Если не надо отправлять заголовок с названием операции - вырезаем его
            if (!sendOperationNameHeader) {
                (_b = config === null || config === void 0 ? void 0 : config.headers) === null || _b === void 0 ? true : delete _b[operationNameHeader];
            }
        }
        return config;
    });
    // Скидываем метрики
    axiosInstance.interceptors.response.use(
    // 2XX OK
    function (resp) {
        var _a;
        if (!((_a = resp.config.url) === null || _a === void 0 ? void 0 : _a.includes('graphql'))) {
            return resp;
        }
        var apiStatus = responseToStatus(resp);
        if (apiStatus && resp.status !== apiStatus) {
            // Удалим статус, так как сами его сматчили из gql ответа
            delete resp.status;
        }
        (0, global_1.coreKeeperAPI)(resp, __assign(__assign({}, extra), { url: getKeeperGQLUrl(resp, bindedGetOperationNameHandler), duration: getKeeperDuration(resp), apiStatus: apiStatus }));
        return resp;
    }, 
    // Error handling
    function (err) {
        var _a;
        if (!((_a = err.config.url) === null || _a === void 0 ? void 0 : _a.includes('graphql'))) {
            return Promise.reject(err);
        }
        // Если ошибка, оставим статус, который есть. Так как нет GQL ответа
        (0, global_1.coreKeeperAPI)(err.request, __assign(__assign({}, extra), { url: getKeeperGQLUrl(err, bindedGetOperationNameHandler), duration: getKeeperDuration(err) }));
        return Promise.reject(err);
    });
}
exports.addGQLKeeperInterceptors = addGQLKeeperInterceptors;
function addKeeperMeta(axiosInstance) {
    axiosInstance.interceptors.request.use(function (config) {
        config.keeper = {
            start: (0, util_now_1.now)(),
        };
        return config;
    });
}
function getKeeperDuration(val) {
    var start = getKeeperStart(val);
    return start ? (0, util_now_1.now)() - start : 0;
}
function getKeeperGQLUrl(val, getOperationName) {
    var operationName = getOperationName(val);
    return "".concat(val === null || val === void 0 ? void 0 : val.config.url, "/").concat(operationName);
}
function getKeeperStart(val) {
    var _a;
    var cfg = undefined;
    if (val && 'response' in val) {
        val = val.response;
    }
    if (val && 'config' in val) {
        cfg = val.config;
    }
    return (cfg && 'keeper' in cfg && ((_a = cfg.keeper) === null || _a === void 0 ? void 0 : _a.start)) || 0;
}
var getOperationNameFromRequestConfig = function (val) {
    var cfg = undefined;
    if (val && 'response' in val) {
        val = val.response;
    }
    if (val && 'config' in val) {
        cfg = val.config;
    }
    return (cfg && 'operationName' in cfg && cfg.operationName) || 'unk';
};
//# sourceMappingURL=axios.js.map